import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import showAlert from 'utils/showAlert';

export default function JoinOrg(props) {
  let joinOrgIcon = require("images/lite/icons/search.svg");
  joinOrgIcon = <img className="onboarding-icon" src={`/datapulse${joinOrgIcon}`} />
  
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isJoining, setIsJoining] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [org, setOrg] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const showModal = () => setIsModalVisible(true);
  const hideModal = () => setIsModalVisible(false);

  const joinOrg = async (event) => {
    event.preventDefault();
    let hasError = false;

    if (!org) {
      hasError = true;
      showAlert("Please search for an organization before joining.", "danger");
    }

    if (hasError) {
      return;
    }

    setIsJoining(true);

    try {
      const response = await fetch(`/datapulse/organization/join`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
        },
        body: JSON.stringify({ org_id: org.id, invite_code: org.invite_code }),
      });

      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          hideModal();
          const turbolinksEvent = new Event("turbolinks:request-start");
          document.dispatchEvent(turbolinksEvent); // Emit this event to start the loading spinner
          window.location.href = "/datapulse";
        } else {
          if (data.error) {
            showAlert(data.error, "danger");
          } else {
            showAlert("An error occurred while joining the organization. Please try again.", "danger");
          }
        }

      } else {
        showAlert("An error occurred while joining the organization. Please try again.", "danger");
      }
    } catch (error) {
      console.log(error)
      showAlert("An error occurred while joining the organization. Please try again.", "danger");
    } finally {
      setIsJoining(false);
      setSearchTerm("");
      setOrg(null);
    }
  }


  const searchForOrg = async (event) => {
    event.preventDefault();
    let hasError = false;

    if (!searchTerm) {
      hasError = true;
      document.getElementById("join-org-code").classList.add("lite-invalid-input");
    }

    if (hasError) {
      return;
    }

    setIsSearching(true);
    try {
      const response = await fetch(`/datapulse/organization/search`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
        },
        body: JSON.stringify({ invite_code: searchTerm }),
      });

      console.log(response);

      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          setOrg(data.organization);
        } else {
          if (data.error) {
            showAlert(data.error, "danger");
          } else {
            showAlert("An error occurred while searching for the organization. Please try again.", "danger");
          }
        }

      } else {
        showAlert("An error occurred while searching for the organization. Please try again.", "danger");
      }
    } catch (error) {
      console.log(error)
      showAlert("An error occurred while searching for the organization. Please try again.", "danger");
    } finally {
      setIsSearching(false);
    }
  }

  return (
    <>
      <div className="lite-onboarding-btn join-org" onClick={showModal}>
        {props.customBtnText ? (
          props.customBtnText
        ) : (
          <>
            {joinOrgIcon}
            <p>Join<br></br>organization</p>
          </>
        )}
      </div>

      <Modal show={isModalVisible} onHide={hideModal} className="join-org-modal">
        <Modal.Header closeButton>
          <Modal.Title>Join an organization</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-4 join-org-info">
            <div className="join-org-info-card">
              <div className="lite-form-group mb-4">
                <label className="input-label mb-2" htmlFor="new-org-name">
                  Invite Code
                </label>
                <input
                  type="text"
                  id="join-org-code"
                  className="lite-input"
                  placeholder="Enter invite code"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
              <div className="lite-form-group">
                {org ? (
                  <div className="org-info">
                    <b className="lite-text-success">✔ {org.name} found!</b>
                  </div>
                ) : (
                  <button type="button" className="button b-type-primary b-size-normal" onClick={searchForOrg}>
                    {isSearching ? "Searching..." : "Search"}
                  </button>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
        <div className="lite-modal-footer">
          <button type="button" className="button b-type-secondary b-size-normal" onClick={hideModal} disabled={isJoining}>
            Cancel
          </button>
          <button
            className="button b-type-primary b-size-normal b-color-green"
            id="join-org-button"
            onClick={joinOrg}
            style={!org ? { filter: "brightness(50%)", cursor: "default"} : {}}
            disabled={isJoining || !org}>
            {isJoining ? (
              "Joining..."
            ) : (
              <>
                ✔ Join<span className="desktop-only"> organization</span>
              </>
            )}
          </button>
        </div>
      </Modal>
    </>
  )
}